import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

import $ from 'jquery';

import { initBasics } from './basics.js';
import { initAnimations } from './animations.js';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

$(function() {

    function initPage(){

        const smoother = initAnimations();
        initBasics(smoother);
    }

    initPage();

});